import { datadogRum } from '@datadog/browser-rum'

type LogLevel = 'Verbose' | 'Debug' | 'Info' | 'Warning' | 'Error'

export class Logger {
  private context?: string

  constructor(context?: string) {
    this.context = context
  }

  verbose(message: string | Record<string, unknown>, context?: string): void {
    this.logMessage('Verbose', message, context)
  }

  debug(message: string | Record<string, unknown>, context?: string): void {
    this.logMessage('Debug', message, context)
  }

  info(message: string | Record<string, unknown>, context?: string): void {
    this.logMessage('Info', message, context)
  }

  warn(message: string | Record<string, unknown>, context?: string): void {
    this.logMessage('Warning', message, context)
  }

  error(error?: Error | string, context?: string): void {
    if (error instanceof Error && error.stack) {
      this.logMessage('Error', error.message, context)
      datadogRum.addError(error.message, {
        context: this.getContextMessage(context),
        stack: error.stack,
      })
    } else if (typeof error === 'string') {
      this.logMessage('Error', error, context)
      datadogRum.addError(error, {
        context: this.getContextMessage(context),
      })
    }
  }

  private logMessage(
    level: LogLevel,
    message: string | Record<string, unknown>,
    context?: string
  ) {
    const timestamp = new Date().toISOString()
    const contextMessage = this.getContextMessage(context)

    const logObject = {
      timestamp,
      level,
      context: contextMessage,
      message: typeof message === 'object' ? JSON.stringify(message) : message,
    }

    // Send the structured log to Datadog RUM
    datadogRum.addAction('frontend-allara-log', logObject)
  }

  private getContextMessage(context?: string): string {
    if (this.context && context) {
      return `${this.context}:${context}`
    }

    if (this.context) {
      return this.context
    }

    return context ?? 'Unknown:Unknown'
  }
}
